class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.handleDropdownClick = FooterComponent.handleDropdownClick.bind(this); // Bind the handler to retain context
  }

  connectedCallback() {
    this.handleDropDown();
  }

  disconnectedCallback() {
    this.removeDropDownEvents(); // Remove event listeners when the component is disconnected
  }

  handleDropDown() {
    this.footerItems = this.querySelectorAll(".footer-menu"); // Store reference for later removal
    this.footerItems.forEach((footerItem) => {
      const header = footerItem.querySelector(".footer-menu__header");
      header.addEventListener("click", FooterComponent.handleDropdownClick);
    });
  }

  static handleDropdownClick(event) {
    const footerItem = event.currentTarget.closest(".footer-menu");
    footerItem.classList.toggle("footer-menu--show");
  }

  removeDropDownEvents() {
    // Remove event listeners for each footer menu header
    this.footerItems.forEach((footerItem) => {
      const header = footerItem.querySelector(".footer-menu__header");
      header.removeEventListener("click", this.handleDropdownClick);
    });
  }
}

customElements.define("footer-component", FooterComponent);
